/**
 * EditAdc.js
 * Created by calhosh on 11/16/2020.
 */

import React from 'react';
import styled from 'styled-components';
import Loader from '../LoadingIndicator/LoadingIndicator';
import Modal from '../../Common/Modal/Modal';

export default function EditModal(props) {
	const {
		body,
		cancelBtnTitle,
		closeTitle,
		confirmBtnTitle,
		modalSize = 'medium',
		onConfirmClick,
		onHide,
		show,
		showLoader,
		showButtons = true,
		showConfirm = true,
		title
	} = props;

	return (
		<Modal
			show={show}
			onHide={onHide}
			modalsize={modalSize}
			title={title}
			showButtons={showButtons}
			confirmBtnTitle={confirmBtnTitle}
			onOkClick={onConfirmClick}
			closeBtnTitle={showConfirm === true ? cancelBtnTitle : closeTitle}
			closeTitle={closeTitle}
			modalBodyStyle="EditAdcModalBody"
			modalContainerClass="EditAdcModalContainer"
			hideConfirmButton={!showConfirm}
		>
			<StyledEditModalWrapper className="StyledEditADCWrapper">
				<Loader show={showLoader} />
				{body}
			</StyledEditModalWrapper>
		</Modal>
	);
}

const StyledEditModalWrapper = styled.section`
	height: 100%;
	.SharedBannerWrapper {
		.bannerLabel {
			margin: var(--px-10) 0 var(--px-20) 0;
			width: auto;
			.motif-toast-close-button {
				display: none;
			}
		}
		.AdcModalDescriptionTitle {
			font-size: var(--px-14);
			font-weight: 300;
			color: var(--neutrals-900);
			line-height: normal;
		}
	}
	.editAdcParentName {
		margin: var(--px-10) 0 0 0;
		font-weight: 400;
		font-size: var(--px-14);
	}
	.editADCWrapper,
	.editWcgwWrapper,
	.editITAppWrapper,
	.editItControlWrapper,
	.editItRiskWrapper {
		height: 100%;
		font-size: var(--px-12);
		padding: var(--px-10) var(--px-20);
		.editItRiskHeading {
			margin-bottom: var(--px-10);
		}
		.editADCHeading,
		.editWcgwHeading,
		.editITAppHeading {
			font-size: var(--px-14);
			font-weight: 300;
			color: var(--neutrals-900);
			line-height: normal;
		}
		.parentEntityHeading {
			margin: var(--px-10) 0 0 0;
			line-height: var(--px-20);
		}
		.SharedBannerWrapper {
			.bannerLabel {
				margin: var(--px-10) 0 var(--px-20) 0;
				width: auto;
				.motif-toast-close-button {
					display: none;
				}
			}
			.AdcModalDescriptionTitle {
				font-size: var(--px-14);
				font-weight: 300;
				color: var(--neutrals-900);
				line-height: normal;
			}
		}
		.editAdcTextArea {
			.motif-text-area {
				min-height: var(--px-100) !important;
			}
		}
		.editAdcParentName {
			margin: var(--px-10) 0 0 0;
			font-weight: 400;
			font-size: var(--px-14);
		}
		.motif-form-field {
			margin-bottom: var(--px-10);
		}
		textarea {
			min-height: var(--px-130) !important;
		}
		.editITAppStrategy {
			display: block;
			margin-top: var(--px-20);
			.itAppStrategyText {
				color: var(--neutrals-900);
				font-size: var(--px-14);
				font-weight: 300;
				margin-bottom: var(--px-8);
			}
		}
		.motif-content-switcher {
			.motif-button {
				width: var(--px-180);
			}
		}
		.itApplicationText {
			margin-top: var(--px-20);
			color: var(--neutrals-900);
			font-size: var(--px-14);
			font-weight: 300;
			.itApplicationTypeVal {
				margin-left: var(--px-5);
				font-weight: bold;
			}
		}
		.SharedFormLabel {
			margin: 0 0 var(--px-10) 0;
			width: 100%;
			box-shadow: rgba(0, 0, 0, 0.2) 0 0 var(--px-6) 0;
			.SharedFormLabelText {
				font-size: var(--px-14);
			}
		}
	}
`;
